import * as React from 'react';

import StatusLabel from 'components/status-label/StatusLabel';

import { __t, applyTranslations } from 'utils/language';
import { STATUS_LABEL_MAP } from 'utils/helper/common';

import './deliverable-custom-trigger-overlay.scss';

applyTranslations(require('locales/common/collabary-common.i18n.json'));

const DeliverableCustomTriggerOverlay = (
  item
): React.ReactNode => {
  if (!item.isPublishedToClient) {
    return null;
  }

  return (
    <div className="deliverable-custom-trigger-overlay">
      <StatusLabel
        size="micro"
        type={STATUS_LABEL_MAP[item.approvalStatus]}
        label={__t(`collabary_common.status.${item.approvalStatus}`)}
      />
    </div>
  );
};

export default DeliverableCustomTriggerOverlay;
